import {
  GREENFIELD_SHARING,
  HIDDEN,
  OLAPS_ONLY,
  SHARING,
  type SharingType,
} from '@/constants/data_shares';

import type { SharingLevelVariantType } from './types';

export const SHARING_LEVEL_VARIANT: Record<
  SharingType,
  SharingLevelVariantType
> = {
  [GREENFIELD_SHARING]: 'all',
  [SHARING]: 'overlaps',
  [OLAPS_ONLY]: 'counts',
  [HIDDEN]: 'hidden',
};

export const SHARING_LEVEL_VARIANT_LABEL: Record<
  SharingLevelVariantType,
  string
> = {
  all: 'All',
  overlaps: 'Overlaps',
  counts: 'Counts',
  hidden: 'Hidden',
  request: 'Request',
  pending: 'Pending',
};
